import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useAuth } from '@react-components/auth';
import { brand } from './brand';
import { AuthScaffold, PrimaryButton, ScreenHeading } from './AuthScaffold';
/**
 * MagicLinkLandingPage — mounted at
 * /:basePath/otp/magic/:companyKey/:emailAddress/:magicToken.
 *
 * Verifies the magic link on mount via useAuth().verifyMagicLink. On success
 * the auth context flips isLoggedIn and the normal post-login redirect takes
 * over; on failure we show an error with a route back to the code screen.
 * @param root0
 * @param root0.basePath
 */
export function MagicLinkLandingPage(_a) {
    var _b = _a.basePath, basePath = _b === void 0 ? '' : _b;
    var _c = useParams(), _d = _c.companyKey, companyKey = _d === void 0 ? '' : _d, _e = _c.emailAddress, emailAddress = _e === void 0 ? '' : _e, _f = _c.magicToken, magicToken = _f === void 0 ? '' : _f;
    var verifyMagicLink = useAuth().verifyMagicLink;
    var navigate = useNavigate();
    var _g = useState(null), error = _g[0], setError = _g[1];
    useEffect(function () {
        if (!companyKey || !emailAddress || !magicToken) {
            setError('Invalid magic link — required parameters are missing.');
            return;
        }
        verifyMagicLink(companyKey, emailAddress, magicToken).catch(function (err) {
            setError(err instanceof Error ?
                err.message :
                'An unknown error occurred.');
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var prefix = basePath ? "/".concat(basePath) : '';
    return (_jsx(AuthScaffold, { children: error ? (_jsxs(Stack, { spacing: 2.25, children: [_jsx(ScreenHeading, { title: "Sign-in failed", subtitle: error }), _jsx(PrimaryButton, { onClick: function () { return navigate("".concat(prefix, "/otp/").concat(companyKey)); }, children: 'Back to sign in' })] })) : (_jsxs(Stack, { spacing: 1.5, alignItems: "center", sx: { py: 2 }, children: [_jsx(CircularProgress, { sx: { color: brand.primary } }), _jsx(Typography, { sx: { color: brand.textSecondary }, children: 'Signing you in…' })] })) }));
}
export default MagicLinkLandingPage;
